module.exports = __webpack_public_path__ + "img/expense-icon.6383911a.png";